import { toast } from "sonner";
import request from "../../helpers/request";
export const postDocumentacaoAVCB = async (formData: FormData) => {
  const url = `${process.env.REACT_APP_API}/documentacaoAVCB`;
  const result = await request({ url, method: "POST", data: formData });

  if (result.status === 200) {
    toast.success("Arquivo enviado com sucesso!");
    return result.data;
  } else {
    toast.error("Falha ao enviar o arquivo.");
    throw new Error(
      result.data?.message || "Erro desconhecido ao enviar o arquivo."
    );
  }
};
